import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  return (
    <Helmet>
      {/* Primary Meta Tags (in German) */}
      <title>
        fahrschul-kurse - Beste Fahrschule in Winterthur | Günstige
        Fahrlektionen & Unterstützung
      </title>
      <meta
        name="description"
        content="fahrschul-kurse bietet die besten Fahrlektionen und Unterstützung in Winterthur zu unschlagbaren Preisen. Melden Sie sich bei der top-bewerteten Fahrschule an, um professionelle Ausbildungen zu erhalten und die Fahrprüfung mit Sicherheit zu bestehen."
      />

      {/* Open Graph / Facebook */}
      <meta
        property="og:title"
        content="fahrschul-kurse - Beste Fahrschule in Winterthur | Günstige Fahrlektionen & Unterstützung"
      />
      <meta
        property="og:description"
        content="fahrschul-kurse ist Ihre zuverlässige Fahrschule in Winterthur, die günstige Fahrlektionen und umfassende Unterstützung anbietet. Profitieren Sie von kompetenter Ausbildung zu fairen Preisen!"
      />
      <meta property="og:image" content="/path-to-image.jpg" />
      <meta property="og:url" content="https://www.fahrschul-kurse.ch" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta
        name="twitter:title"
        content="fahrschul-kurse – Beste Fahrschule in Winterthur | Günstige Fahrlektionen & Unterstützung"
      />
      <meta
        name="twitter:description"
        content="fahrschul-kurse bietet erschwingliche Fahrlektionen und Aid in Winterthur. Jetzt anmelden und erfolgreich die Fahrprüfung bestehen!"
      />
      <meta name="twitter:image" content="/path-to-image.jpg" />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Robots */}
      <meta name="robots" content="index, follow" />

      {/* Keywords (German) */}
      <meta
        name="keywords"
        content="fahrschul-kurse, Fahrschule Winterthur, Fahrlektion, VKU, Fahrprüfung, verkehrskunde, günstige Fahrstunden, beste Fahrschule, Führerausweis, Römerstrasse 76, Winterthur"
      />

      {/* Viewport */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />

      {/* Author */}
      <meta name="author" content="fahrschul-kurse Driving School" />

      {/* Language set to German */}
      <meta name="language" content="de" />

      {/* Structured Data (JSON-LD) in German */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "DrivingSchool",
          name: "fahrschul-kurse",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Römerstrasse 76",
            addressLocality: "Winterthur",
            postalCode: "8404",
            addressCountry: "Schweiz",
          },
          telephone: "+41 76 472 75 63",
          url: "https://www.fahrschul-kurse.ch",
          sameAs: [
            "https://www.facebook.com/fahrschulkurseWinterthur",
            "https://www.instagram.com/fahrschulkurseWinterthur",
          ],
          priceRange: "$$",
          areaServed: {
            "@type": "Place",
            name: "Winterthur, Schweiz",
          },
          description:
            "fahrschul-kurse bietet preiswerte Fahrlektionen und umfassende Unterstützung in Winterthur. Lernen Sie sicher fahren mit professionellen Fahrlehrern zu fairen Preisen.",
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
